<div [ngSwitch]="props?.matButtonName" [class]="props?.class">
	<button *ngSwitchCase="'mat-raised-button'" mat-raised-button [type]="props?.btnType || 'button'" [color]="props?.color"
		[ngClass]="props?.buttonClassArray" (click)="onClick($event)" [disabled]="props?.disabled" [matTooltip]="props?.tooltip"
		[matTooltipPosition]="props?.tooltipPosition || 'above'">
		<span [class]="props?.labelClass">{{props?.label}}</span>
		<mat-icon *ngIf="props?.icon">{{props?.icon}}</mat-icon>
	</button>
	<button *ngSwitchCase="'mat-stroked-button'" mat-stroked-button [type]="props?.btnType || 'button'" [color]="props?.color"
		[ngClass]="props?.buttonClassArray" (click)="onClick($event)" [disabled]="props?.disabled" [matTooltip]="props?.tooltip"
		[matTooltipPosition]="props?.tooltipPosition || 'above'">
		<span [class]="props?.labelClass">{{props?.label}}</span>
		<mat-icon *ngIf="props?.icon">{{props?.icon}}</mat-icon>
	</button>
	<button *ngSwitchCase="'mat-flat-button'" mat-flat-button [type]="props?.btnType || 'button'" [color]="props?.color"
		[ngClass]="props?.buttonClassArray" (click)="onClick($event)" [disabled]="props?.disabled" [matTooltip]="props?.tooltip"
		[matTooltipPosition]="props?.tooltipPosition || 'above'">
		<span [class]="props?.labelClass">{{props?.label}}</span>
	</button>
	<button *ngSwitchCase="'mat-icon-button'" mat-icon-button [type]="props?.btnType || 'button'" [attr.aria-label]="props?.ariaLabel"
		[ngClass]="props?.buttonClassArray" (click)="onClick($event)" [disabled]="props?.disabled" [matTooltip]="props?.tooltip"
		[matTooltipPosition]="props?.tooltipPosition || 'above'">
		<mat-icon>{{props?.icon}}</mat-icon>
	</button>
	<ng-container *ngSwitchCase="'mat-menu-button'">
		<button type="button" mat-button [matMenuTriggerFor]="menu" [color]="props?.color" [ngClass]="props?.buttonClassArray"
			[disabled]="props?.disabled" [matTooltip]="props?.tooltip" [matTooltipPosition]="props?.tooltipPosition || 'above'">
			<span [class]="props?.labelClass">{{props?.label}}</span>
			<mat-icon *ngIf="props?.indicateMenuWithArrowDownIcon">keyboard_arrow_down</mat-icon>
			<mat-icon *ngIf="props?.icon">{{props?.icon}}</mat-icon>
		</button>
		<mat-menu #menu="matMenu" xPosition="before" yPosition="below" overlapTrigger="false">
			<button mat-menu-item class="formly-mat-button-mat-menu-item" *ngFor="let item of props?.menuItems" (click)="item.onClick()">
				<mat-icon>{{item.icon}}</mat-icon>
				{{item.label}}
			</button>
		</mat-menu>
	</ng-container>
	<button *ngSwitchDefault mat-button [type]="props?.btnType || 'button'" [color]="props?.color" [ngClass]="props?.buttonClassArray"
		(click)="onClick($event)" [disabled]="props?.disabled" [matTooltip]="props?.tooltip" [matTooltipPosition]="props?.tooltipPosition || 'above'">
		<mat-icon *ngIf="props?.icon" mat-icon-button [class]="props?.iconClass">{{props?.icon}}</mat-icon>
		<span [class]="props?.labelClass">{{props?.label}}</span>
	</button>
</div>